import { Modules } from '@/types/generated'
import Role = Modules.Shared.Enums.RoleEnum
import RoleEnum = Modules.Shared.Enums.RoleEnum
import OrganizationSettingsData = Modules.Organization.OrganizationSettingsData
import EvaluatorTypeEnum = Modules.Evaluation.Enums.EvaluatorTypeEnum

export const resolveUserRoleVariant = (role: string) => {
  const roleLowerCase = role.toLowerCase()

  if (roleLowerCase === 'observer')
    return { color: 'secondary', icon: 'tabler-eye' }
  if (roleLowerCase === 'manager')
    return { color: 'warning', icon: 'tabler-crown' }
  if (roleLowerCase === 'expert')
    return { color: 'info', icon: 'tabler-edit' }
  if (roleLowerCase === RoleEnum.LEAD_EXPERT)
    return { color: 'info', icon: 'tabler-mood-edit' }
  if (roleLowerCase === RoleEnum.SCOPED_ADMIN)
    return { color: 'warning', icon: 'tabler-diamond' }
  if (roleLowerCase === 'admin')
    return { color: 'error', icon: 'tabler-vip' }
  if (roleLowerCase === 'support')
    return { color: 'success', icon: 'tabler-message-chatbot' }
  if (roleLowerCase === RoleEnum.EARLY_ACCESS)
    return { color: '#8F00FF', icon: 'tabler-rocket' }
  if (roleLowerCase === RoleEnum.HEAD)
    return { color: 'success', icon: 'tabler-users-group' }

  return { color: 'primary', icon: 'tabler-user' }
}

export type NonEmptyArray<T> = [T, ...T[]]

export const resolveUserStatusVariant = (stat: string) => {
  const statLowerCase = stat.toLowerCase()
  if (statLowerCase === 'pending')
    return 'warning'
  if (statLowerCase === 'active')
    return 'success'
  if (statLowerCase === 'inactive')
    return 'secondary'

  return 'primary'
}

export const userIsManager = (roles: string[]): boolean => {
  return roles.includes(Role.MANAGER) || roles.includes(Role.SCOPED_ADMIN)
}

export const userIsScopedAdmin = (roles: string[]): boolean => {
  return roles.includes(Role.SCOPED_ADMIN)
}

export const userHasEarlyAccess = (roles: string[]): boolean => {
  return roles.includes(Role.EARLY_ACCESS) || roles.includes(Role.ADMIN)
    || roles.includes(Role.SCOPED_ADMIN)
}

export const userIsExpert = (roles: string[]): boolean => {
  return roles.includes(Role.EXPERT) || roles.includes(Role.LEAD_EXPERT)
}

export const userIsLeadExpert = (roles: string[]): boolean => {
  return roles.includes(Role.LEAD_EXPERT)
}

export const userIsAdmin = (roles: string[]): boolean => {
  return roles.includes(Role.ADMIN)
}

export const userIsPlayer = (roles: string[]): boolean => {
  return roles.includes(Role.PLAYER)
}

export const userIsSupport = (roles: string[]): boolean => {
  return roles.includes(Role.SUPPORT)
}

export const userIsHead = (roles: string[]): boolean => {
  return roles.includes(Role.HEAD)
}

export const hideAiResults = (roles: string[], settings?: OrganizationSettingsData | null): boolean => {
  return (settings?.hideAiResults ?? false)
    && !roles.includes(Role.ADMIN)
    && !roles.includes(Role.SCOPED_ADMIN)
}

export const hidePlayerRating = (roles: string[], settings?: OrganizationSettingsData | null): boolean => {
  return (settings?.hidePlayerRating ?? false) && userIsPlayer(roles)
}

export const visibleEvaluatorTypes = (roles: string[], settings?: OrganizationSettingsData | null): EvaluatorTypeEnum[] => {
  return Object.values(EvaluatorTypeEnum)
    .filter(type => type !== EvaluatorTypeEnum.AI || !hideAiResults(roles, settings))
}

export const resolveUserStatus = (item: any) => {
  if (!item.is_active)
    return 'inactive'

  if (item.email_verified_at === null)
    return 'pending'

  return 'active'
}

export function arrayBufferToAudioData(buffer: ArrayBuffer) {
  return Float32Array.from(new Int16Array(buffer), value => value / 0x8000)
}

export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binaryString = window.atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++)
    bytes[i] = binaryString.charCodeAt(i)

  return bytes.buffer
}

export function arrayBufferToBase64(buffer: ArrayBuffer) {
  return window.btoa(String.fromCharCode(...new Uint8Array(buffer)))
}
